import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { TransactionsDialogComponent } from "../transactions-dialog/transactions-dialog-component";
import { NotesDialogComponent } from "../notes-dialog/notes-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { WebTransaction } from "../../../models";
import { BreakpointObserver } from "@angular/cdk/layout";
import { MatPaginator } from "@angular/material/paginator";

@Component({
    selector: "app-transactions-card",
    templateUrl: "./transactions-card.component.html",
    styleUrls: ["./transactions-card.component.scss"],
})
export class TransactionsCardComponent implements OnInit
{

    @Input() transactions: WebTransaction[];

    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

    myColumns: number;
    height: string;
    isMobile: boolean;

    constructor(
        public dialog: MatDialog,
        private breakpointObserver: BreakpointObserver,

    ) { }

    ngOnInit(): void
    {

        this.breakpointObserver.observe("(max-width: 650px)").subscribe(result =>
        {
            this.isMobile = result.matches;
            this.setColumns();
        });
    }

    setColumns()
    {
        if (this.isMobile)
        {
            this.myColumns = 3;
            this.height = "100%";
        } 
        else
        {
            this.myColumns = 7;
            this.height = "50%";
        }
    }

    openDialog(transaction: WebTransaction): void
    {

        this.dialog.open(TransactionsDialogComponent, {
            width: "100%",
            height: this.height,
            maxWidth: 950,
            data: { transaction },
            restoreFocus: true,
        });
    }

    openNotesDialog(transaction: WebTransaction): void
    {
        this.dialog.open(NotesDialogComponent, {
            width: "100%",
            height: this.height,
            maxWidth: 950,
            data: { transaction },
            restoreFocus: true,
        });
    }
}
